import { Container } from 'beam';
import CubicBezier from './helpers/cubicBezier';
import Box from './Box';

import maskColors from './maskColors'

const SCALE_MULT     = 0.1; // ratio between size of the box and distance to camera.

export default class GLVerticals extends HTMLElement {
     
    constructor() {
        super();
        this.resize = this.resize.bind(this);
        this.update = this.update.bind(this);
    }

    connectedCallback() {
        this.__isConnected__ = true;
        window.addEventListener('resize', this.resize);
        document.addEventListener('resize', this.resize);

        let node = this;
        let i=0;
        while (node.parentNode && i<100) { 
            if (node.parentNode.tagName == 'WEBGL-SCENE') {
                this.$glScene = node.parentNode;
                break;
            }
            node = node.parentNode;
            i++;
        }

        if (!this.$glScene) {
            console.warn("missing webgl scene !")
            return;
        }
        
  
        requestAnimationFrame(()=>{
            this.init();
            this.update();
        })
    }

    init() {
        this.renderer = this.$glScene.renderer;
        this.container = new Container();
        this.$glScene.addChild(this.container);

        this.data = {
            slides: this.hasAttribute('data-slides') ? JSON.parse( this.getAttribute('data-slides') ) : [],
        }

        this.boxes = []
        for (let i=0; i<this.data.slides.length; i++) {
            if (this.data.slides[i]?.video_thumbnail?.url) {
                console.log('VIDEO', this.data.slides[i]?.video_thumbnail?.url)
            }
            const box = new Box(this.renderer, {
                src:        this.data.slides[i]?.video_thumbnail?.url || this.data.slides[i]?.webgl_image?.url,//`/wp-content/themes/wp-base-theme/dist/assets/textures/${(i%5)+1}.jpg`,
                maskChanel: maskColors[ i % maskColors.length ],
                scale:      SCALE_MULT,
                fitViewport: true,
                skipPortraitScale: true,
                
            });
            box.container.scale[0] = 0
            box.container.scale[1] = 0
            box.container.scale[2] = 0
            this.boxes.push( box )
            this.container.add(box.container);
            this.$glScene.registerBox(box);
        }
    }

    disconnectedCallback() {
        this.__isConnected__ = false;
        window.removeEventListener('resize', this.resize);
        this.$glScene.removeChild(this.container);
    }

    resize() {

    }

    update() {

        if (!this.__isConnected__) {
            return;
        }

        requestAnimationFrame(()=>{
            this.update();
        });

        if (!this.$glScene) {
            return
        }
        
        const progress      = Math.max(0, Math.min(1, (this.$glScene._scroll - window.innerHeight) / (window.innerHeight )));
        const easedProgress = CubicBezier(0.775, 0.065, 0.345, 0.880, progress, 1 );
        


        this.boxes.forEach((box, i) => {

            box.boxScale = (window.innerHeight  / 100 * SCALE_MULT) ;

            if (i == 0) {
                const leaveProgress         =  Math.max(0, Math.min(1, (this.$glScene._scroll - window.innerHeight * (2) ) / (window.innerHeight)));
                const easedPLeavedrogress   = CubicBezier( 0.775, 0.065, 0.345, 0.880, leaveProgress, 1 );

                box.container.scale[0] += ( (  (window.innerHeight  / 100 * SCALE_MULT)   * ((easedProgress) * (1 - (easedPLeavedrogress) * 0.5) ) ) - box.container.scale[0]) * 0.1;
                box.container.scale[1] += ( (  (window.innerHeight  / 100 * SCALE_MULT)   * ((easedProgress) * (1 - (easedPLeavedrogress) * 0.5) ) ) - box.container.scale[1]) * 0.1;
                box.container.scale[2] += ( (  (window.innerHeight  / 100 * SCALE_MULT)   * ((easedProgress) * (1 - (easedPLeavedrogress) * 0.5) ) ) - box.container.scale[2]) * 0.1;
                
                box.container.rotation[0] +=  (( (easedPLeavedrogress) * -0.1) - box.container.rotation[0]) * 0.1;
                box.container.rotation[1] +=  (((-0.5 + easedProgress * 0.5)  + (easedPLeavedrogress) * 1) - box.container.rotation[1]) * 0.1;
                box.container.rotation[2] +=  (( (easedPLeavedrogress) * 0.1) - box.container.rotation[2]) * 0.1;
                
                box.container.position[0] += (((window.innerHeight * 2 * -0.75 ) * (easedPLeavedrogress)) * SCALE_MULT - box.container.position[0]) * 0.1;
                box.container.position[1] += (((window.innerHeight *  1) * (easedPLeavedrogress)) * SCALE_MULT - box.container.position[1]) * 0.1;
                box.container.position[2] += (((box.container.scale[0] * box.boxDepth / -2 + this.$glScene.camera.position[2]* (1. - SCALE_MULT) ) + (-window.innerHeight * 6 + (easedProgress) * window.innerHeight * 6)) - box.container.position[2]) * 0.1;
              
                box[easedProgress > 0.5 && leaveProgress <= 0.5 ? 'play' : 'pause']();
            }

            if (i == 1) {
                const scaleProgress       = Math.max(0, Math.min(1, (this.$glScene._scroll - window.innerHeight * (1) ) / (window.innerHeight )));
                const easedScaleProgress  = CubicBezier( 0.775, 0.065, 0.345, 0.880, scaleProgress, 1 );

                const progressOffsetY      = Math.max(0, Math.min(1, (this.$glScene._scroll - window.innerHeight * (2) ) / (window.innerHeight )));
                const easedProgressOffsetY = CubicBezier( 0.775, 0.065, 0.345, 0.880, progressOffsetY, 1 );
                
                const leaveProgress         =  Math.max(0, Math.min(1, (this.$glScene._scroll - window.innerHeight * (3) ) / (window.innerHeight )));
                const easedLeavedrogress    = CubicBezier( 0.775, 0.065, 0.345, 0.880, leaveProgress, 1 );

                box.container.scale[0] += (   ( ( window.innerHeight / 100 * SCALE_MULT)  * (easedScaleProgress * (easedProgressOffsetY*0.5+0.5)) * (1 - (easedLeavedrogress) * 0.5)) - box.container.scale[0] ) * 0.1 ;
                box.container.scale[1] += (   ( ( window.innerHeight / 100 * SCALE_MULT)  * (easedScaleProgress * (easedProgressOffsetY*0.5+0.5)) * (1 - (easedLeavedrogress) * 0.5)) - box.container.scale[1] ) * 0.1 ;
                box.container.scale[2] += (   ( ( window.innerHeight / 100 * SCALE_MULT)  * (easedScaleProgress * (easedProgressOffsetY*0.5+0.5)) * (1 - (easedLeavedrogress) * 0.5)) - box.container.scale[2] ) * 0.1 ;

                box.container.rotation[0] +=  (( (easedLeavedrogress) * -0.1) - box.container.rotation[0]) * 0.1;
                box.container.rotation[1] += ((((-0.5 + easedScaleProgress * 0.5) * -1)  + (easedLeavedrogress)  +    (1 - (easedProgressOffsetY)) * -1) - box.container.rotation[1]) * 0.1; 
                box.container.rotation[2] +=  (( (easedLeavedrogress) * 0.1) - box.container.rotation[2]) * 0.1;

                box.container.position[0] += (((window.innerHeight * 2  ) * (1 - (easedProgressOffsetY)) + ((window.innerHeight * 2 * -0.75 ) * (easedLeavedrogress))   ) * SCALE_MULT  - box.container.position[0]) * 0.1;
                box.container.position[1] += (((window.innerHeight * -1 ) * (1 - (easedProgressOffsetY)) + ((window.innerHeight *  1) * (easedLeavedrogress))) * SCALE_MULT - box.container.position[1]) * 0.1;
                box.container.position[2] =  box.container.scale[0] * box.boxDepth / -2 + this.$glScene.camera.position[2] * (1. - SCALE_MULT);


                box[progressOffsetY > 0.5 && easedLeavedrogress <= 0.5 ? 'play' : 'pause']();
            }

            if (i ==2) {
                
                const scaleProgress        = Math.max(0, Math.min(1, (this.$glScene._scroll - window.innerHeight * (1) ) / (window.innerHeight )));
                const easedScaleProgress   = CubicBezier( 0.775, 0.065, 0.345, 0.880, scaleProgress, 1 );
                
                const progressOffsetY      = Math.max(0, Math.min(1, (this.$glScene._scroll - window.innerHeight * (3) ) / (window.innerHeight )));
                const easedProgressOffsetY = CubicBezier( 0.775, 0.065, 0.345, 0.880, progressOffsetY, 1 );

                const leaveProgress        = Math.max(0, Math.min(1, (this.$glScene._scroll - window.innerHeight * (4) ) / (window.innerHeight )));
                const easedPLeavedrogress  = CubicBezier( 0.775, 0.065, 0.345, 0.880, leaveProgress, 1 );

                box.container.scale[0] += (   ( ( window.innerHeight / 100 * SCALE_MULT)  * (easedScaleProgress * (easedProgressOffsetY*0.5+0.5)) * (1 - (easedPLeavedrogress) * 0.5) ) - box.container.scale[0] ) * 0.1 ;
                box.container.scale[1] += (   ( ( window.innerHeight / 100 * SCALE_MULT)  * (easedScaleProgress * (easedProgressOffsetY*0.5+0.5)) * (1 - (easedPLeavedrogress) * 0.5) ) - box.container.scale[1] ) * 0.1 ;
                box.container.scale[2] += (   ( ( window.innerHeight / 100 * SCALE_MULT)  * (easedScaleProgress * (easedProgressOffsetY*0.5+0.5)) * (1 - (easedPLeavedrogress) * 0.5) ) - box.container.scale[2] ) * 0.1 ;

                box.container.rotation[0] +=  (( (easedPLeavedrogress) * -0.1) - box.container.rotation[0]) * 0.1;
                box.container.rotation[1] += ((((-0.5 + easedScaleProgress * 0.5) * -1)  + (easedPLeavedrogress)  +    (1 - (easedProgressOffsetY )) * -1) - box.container.rotation[1]) * 0.1; 
                box.container.rotation[2] +=  (( (easedPLeavedrogress) * 0.1) - box.container.rotation[2]) * 0.1;

                box.container.position[0] += (((window.innerHeight * 2  ) * (1 - (easedProgressOffsetY )) + ((window.innerHeight * 2 * -0.75 ) * (easedPLeavedrogress))   ) * SCALE_MULT  - box.container.position[0]) * 0.1;
                box.container.position[1] += (((window.innerHeight * -1 ) * (1 - (easedProgressOffsetY )) + ((window.innerHeight *  1) * (easedPLeavedrogress)))  * SCALE_MULT - box.container.position[1]) * 0.1;
                box.container.position[2] = box.container.scale[0] * box.boxDepth / -2 + this.$glScene.camera.position[2] * (1. - SCALE_MULT);

                box[progressOffsetY > 0.5 && easedPLeavedrogress <= 0.5 ? 'play' : 'pause']();
            }

            box.container.updateMatrix();
            box.container.updateWorldMatrix();
        });
    }

}

customElements.define('gl-verticals', GLVerticals)